import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Card } from '@mews-commander/ui';
import { getEnterpriseSettingsWithDefaults } from '../../selectors/settings';
import { CardTitleElement } from '../style';
import EnterpriseForm from './EnterpriseForm';

const EnterpriseView = ({ scope, enterpriseSettings }: $TSFixMe) => (
    <>
        <CardTitleElement>
            <LocalizedText textKey={TextKey.EnterpriseSettings} />
        </CardTitleElement>
        <Card>
            <EnterpriseForm initialValues={enterpriseSettings} form={scope} scope={scope} />
        </Card>
    </>
);

export default connect(
    createStructuredSelector({
        enterpriseSettings: getEnterpriseSettingsWithDefaults,
    })
)(EnterpriseView);
